import { SnapshotDetails } from "./snapshot-details";
export class CCSnapshot {
    constructor() {
        this.list = new Array<SnapshotDetails>();
    }
    previousMonthName: string;
    currentMonthName: string;
    recognizedManagers:string;
    totalGlobalCC:string;
    globalCC:Number;
    nextLevel:string;
    totMgrCount:Number;
    list: SnapshotDetails[];
    currentMonthTotal?:string|number;
}

export class CCSnapshotMonthlyValues {
   
    processingMonth: string;
    processingYear: string;
    personalCCMtd: Number;
    distributorCCMtd: Number;
    totalactiveCCMtd: Number;
    nonmanagerCCMtd: Number;
    leaderCC: Number;
    totalCCMtd: Number;
    netMonthlyBonus: Number;
    currentMonthActive?: boolean;
    endingLevel?: Number;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/cc-snapshot.ts